export function getMonthNameFromNumber(number) {
    var returnString = "";
    number = parseInt(number);
    switch (number) {
        case 1:
            returnString = "Jänner";
            break;
        case 2:
            returnString = "Februar";
            break;
        case 3:
            returnString = "März";
            break;
        case 4:
            returnString = "April";
            break;
        case 5:
            returnString = "Mai";
            break;
        case 6:
            returnString = "Juni";
            break;
        case 7:
            returnString = "Juli";
            break;
        case 8:
            returnString = "August";
            break;
        case 9:
            returnString = "September";
            break;
        case 10:
            returnString = "Oktober";
            break;
        case 11:
            returnString = "November";
            break;
        case 12:
            returnString = "Dezember";
            break;
    }
    return returnString;
}